/**
 * Common functionality used with  @HostListener('document:click', ['$event'])
 *
 * Please note that following this pattern is discouraged, preferred method of achieving the same functionality is to use
 * OnClickOutsideModule directive when possible
 */
export function modalOnClick(event: MouseEvent, customModalCloseCallback: () => void): void {
  const target = event.target as Element
  if (!target.className || !target.className.includes) {
    return
  }
  if (target.className.includes('modal__')) {
    event.stopPropagation()
  } else if (target.className.includes('modal')) {
    customModalCloseCallback()
  }
}
